import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SegnalibriRoutingModule } from './segnalibri-routing.module';
import { SegnalibriComponent } from './segnalibri.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';


@NgModule({
  declarations: [SegnalibriComponent],
  imports: [
    CommonModule,
    SegnalibriRoutingModule,
    CustomMaterialModule,
    ReactiveFormsModule,
    CustomFormControlsModule,
  ]
})
export class SegnalibriModule { }
